module.exports = {
    domain: 'jumbo.cl',
    apikey: {
        abandonedCart: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        catalog: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        chat: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        cms: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        express: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        fidelity: 'EDP4LU8J7OOS8Wil9TmZ',
        headerNotifications: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        orders: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        orderForm: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        proxy: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        promotions: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        shoppingList: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        salesChannel: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        search: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        socket: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        transaction: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        user: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        userAddress: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
        wallet: 'IuimuMneIKJd3tapno2Ag1c1WcAES97j',
    },
    api:{
        abandonedCart: 'https://apijumboweb.smdigital.cl/abandoned-cart/api/v1',
        catalog: 'https://apijumboweb.smdigital.cl/catalog/api/v1',
        catalogV2: 'https://apijumboweb.smdigital.cl/catalog/api/v2',
        chat: 'https://apijumboweb.smdigital.cl/chat/api/v1',
        cms: 'https://apijumboweb.smdigital.cl/cms/api/v1',
        express: 'https://api.smdigital.cl:8443/v0/cl/juboAhoraWeb/proxy/CMS',
        fidelity: 'https://cl-jumboweb-fidelity.ecomm.cencosud.com/api/v1',
        headerNotifications: 'https://apijumboweb.smdigital.cl/notification/api/v1',
        orders: 'https://apijumboweb.smdigital.cl/orders/api/v1',
        ordersV2: 'https://apijumboweb.smdigital.cl/orders/api/v2',
        ordersV3:  'https://apijumboweb.smdigital.cl/orders/api/v3',
        orderForm: 'https://apijumboweb-critical.smdigital.cl/orderform/api/v1',
        orderFormV2: 'https://apijumboweb-critical.smdigital.cl/orderform/api/v2',
        proxy: 'https://apijumboweb.smdigital.cl/proxy/api/v1',
        proxyV2: 'https://apijumboweb.smdigital.cl/proxy/api/v2',
        promotions: 'https://apijumboweb.smdigital.cl/promotions/api/v1',
        shoppingList: 'https://apijumboweb.smdigital.cl/shopping-list/api/v1',
        salesChannel: 'https://apijumboweb.smdigital.cl/sales-channel-geolocation/api/v1',
        salesChannelV2: 'https://apijumboweb.smdigital.cl/sales-channel-geolocation/api/v2',
        salesChannelV3: 'https://apijumboweb.smdigital.cl/sales-channel-geolocation/api/v3',
        search: 'https://apijumboweb.smdigital.cl/search/api/v1',
        searchV2: 'https://apijumboweb.smdigital.cl/search/api/v2',
        socket: 'https://apijumboweb.smdigital.cl/socket',
        transactionV1: 'https://apijumboweb-critical.smdigital.cl/transaction/api/v1',
        transaction: 'https://apijumboweb-critical.smdigital.cl/transaction/api/v2',
        user: 'https://apijumboweb.smdigital.cl/user/api/v1',
        userAddress: 'https://apijumboweb.smdigital.cl/user/address/api/v1',
        userAddressV2: 'https://apijumboweb.smdigital.cl/user/address/api/v2',
        wallet: 'https://apijumboweb-critical.smdigital.cl/wallet/api/v1',
        walletV2: 'https://apijumboweb-critical.smdigital.cl/wallet/api/v2',
    },
    payment:{
        paymentsId: {
            debit : "30",
            promissory : "203",
            oneClick : "201",
            catOneClick : "202",
            debitOneClick : "203"
        },
        paymentsName: {
            oneClick : 'JumboOneClick',
            catOneClick : 'CatOneClick',
            debitOneClick: 'DebitoOneClick'
        },
        walletPaymentsName: {
            oneClick : 'OneClick',
            catOneClick : 'CATOneClick',
            debitOneClick: 'DebitoOneClick'
        }
    },
    features: {
        personalize: {
            orderCollections: false,
            pdp:{
                shopTogether: false,
                sliderSimilar: false
            },
            home: {
                orderIslands: false,
                orderBanner: false
            },
            checkout: {
                sliderRecommended: false
            }
        },
        upsellingCMS: true,
        quickPurchase: true,
        prime: {
            titles: true,
            inscription: true
        },
        balancerWL: {
            status: false,
            path: '/seller/geolocation'
        }
    },
    campaignPersonalize: {
        pdpCampaign: 'pdp-recommendation',
        pdpFilterPack: 'pdp-recommendation-pack',
        pdpFilterSimilar: 'pdp-recommendation-category'
    },
    showTermsModal: true,
    jsonData: {

    },
    version: '',
    maxItemsExpress: '',
    sellerIdFood: '1',
    imageUrl: '',
    googleMaps: {
        api: 'AIzaSyAZZRB2ULTJpGVsBPKhJ6VshxqKqA0hQ9Q',
        apiWithoutRestrictions: 'AIzaSyBwPqTrJhATFWl0INf5V2KhAjukgWib_Ws'
    },
    rutRegex: /^[0-9]{1,2}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9Kk]{1}$/,
    tlfnRegex: /^[+]{0,1}[0-9]{9,11}$/,
    tlfnSmallRegex: /^[0-9]{8,10}$/,
    emailRegex: /^(([^<>()[\]\\.,;:ñáéíóúèàìòù´`$¢\s@"]+(\.[^<>()[\]\\.,;:ñáéíóúèàìòù`´$¢\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    maxItemsOSM: 60,
    searchPagesRedirect: {
        'agenda hora local': '/informaciones/evita-la-fila',
        'agenda hora': '/informaciones/evita-la-fila',
        'agenda tu hora': '/informaciones/evita-la-fila',
        'agendar hora local': '/informaciones/evita-la-fila',
        'agendar hora': '/informaciones/evita-la-fila',
        'evita fila': '/informaciones/evita-la-fila',
        'evita la fila': '/informaciones/evita-la-fila',
        'locales': '/locales',
        'oferta': '/oferta/ofertas-fdm',
        'ofertas': '/oferta/ofertas-fdm',
        'pedir hora': '/informaciones/evita-la-fila',
        'reserva': '/informaciones/evita-la-fila',
        'reservar': '/informaciones/evita-la-fila',
        'tu hora': '/informaciones/evita-la-fila',
        'visita presencial': '/informaciones/evita-la-fila'
    },
    experiments: {
        searchVariantID: 'dxEbdwsXQf-JlZP5byuB7A',
        sliderCartVariantID: 'ufa68wwlSr2hFPco9rijlw',
        reviewVariantID: 'ud4eY4joQSiAkMata4xtkQ',
        exclusiveJumboID: 'YBYYXbUnTYaw5eAaaDJAHQ',
        frequentProductsID: '1lsW7l2xRd6aB7dVze8Spg',
        checkoutID: 'xZr9-JRbRa24qmA1C29Wwg',
        quickPurchaseID: 'RLK9jxqIQPeQPORg0PnKNA',
        preheaderID: 'Rg3P2ZkwRCmJWtucJnytRw',
        shopTogetherID:'FgWCvyj3RAm3ELypJas5SQ',
        suggestionsTagsID: 'jMmx3MzJTN-nMKvIKG9vtQ'
    }
}